import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Email Variant"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-email-variant',
    templateUrl: './icon-email-variant.component.html',
    styleUrls: ['./icon-email-variant.component.scss'],
    standalone: false
})
export class IconEmailVariantComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
